<app-page-header>
  <span class="page-title">
    <h3>Settings</h3>
  </span>
</app-page-header>

<div class="settings-wrapper">
  <div class="settings-card">
    <!-- ================= SIDEBAR ================= -->
    <aside class="settings-sidebar">
      <!-- <div class="settings-sidebar-header">
      <div class="settings-icon">
        <i class="fas fa-sliders-h"></i>
      </div>

      <div>
        <h4>Settings</h4>
        <span>Manage your preferences</span>
      </div>
    </div> -->

      <nav class="settings-navigation">
        <button
          type="button"
          class="settings-tab"
          [class.active]="tabName === 'profile'"
          (click)="selectSettingsTab('profile')"
        >
          <span class="tab-icon">
            <i class="fas fa-user"></i>
          </span>

          <span class="tab-content">
            <strong>Profile</strong>
            <!-- <small>Personal information</small> -->
          </span>

          <i class="fas fa-chevron-right tab-arrow"></i>
        </button>

        <button
          type="button"
          class="settings-tab"
          [class.active]="tabName === 'account'"
          (click)="selectSettingsTab('account')"
        >
          <span class="tab-icon">
            <i class="fas fa-lock"></i>
          </span>

          <span class="tab-content">
            <strong>Change Password</strong>
            <!-- <small>Update your password</small> -->
          </span>

          <i class="fas fa-chevron-right tab-arrow"></i>
        </button>

        <!-- <button type="button" class="settings-tab" [class.active]="tabName === 'layout'"
      (click)="selectSettingsTab('layout')">

      <span class="tab-icon">
        <i class="fas fa-lock"></i>
      </span>

      <span class="tab-content">
        <strong>Layout</strong>
        <small>Update your password</small>
      </span>

      <i class="fas fa-chevron-right tab-arrow"></i>
    </button>

    <button type="button" class="settings-tab" [class.active]="tabName === 'notification'"
      (click)="selectSettingsTab('notification')">

      <span class="tab-icon">
        <i class="fas fa-lock"></i>
      </span>

      <span class="tab-content">
        <strong>Notification</strong>
        <small>Update your password</small>
      </span>

      <i class="fas fa-chevron-right tab-arrow"></i>
    </button> -->

        @if (loggedUserRole == 1 || loggedUserRole == 2) {
        <button
          type="button"
          class="settings-tab"
          [class.active]="tabName === 'logo'"
          (click)="selectSettingsTab('logo')"
        >
          <span class="tab-icon">
            <i class="fas fa-image"></i>
          </span>
          <span class="tab-content">
            <strong>Company Logo</strong>
            <!-- <small>Manage company branding</small> -->
          </span>
          <i class="fas fa-chevron-right tab-arrow"></i>
        </button>
        }
      </nav>
    </aside>

    <!-- ================= CONTENT ================= -->
    <main class="settings-content">
      <div class="settings-content-inner">
        @switch (tabName) { @case ('profile') {
        <div class="settings-panel">
          <!-- Profile content -->
          @if (tabName === 'profile') {
          <div class="profile-settings">
            <form [formGroup]="newUserForm" novalidate>
              <!-- ============================================
                PROFILE TOP CARD
                ============================================= -->
              <div class="profile-intro">
                <div class="profile-avatar-section">
                  <div class="avatar-wrapper">
                    <!-- Empty avatar -->
                    @if (!user_icon) {
                    <empty-uname
                      [userName]="newUserForm.value.first_name"
                      [detailProfile]="true"
                    >
                    </empty-uname>
                    }
                    <!-- User image -->
                    @if (user_icon) {
                    <img
                      [src]="profileUrl + user_icon"
                      class="avatar-img"
                      alt="Profile"
                      (click)="showProfileImage()"
                    />
                    }
                    <!-- Avatar actions -->
                    <div class="avatar-overlay">
                      <button
                        type="button"
                        class="avatar-action"
                        title="Change profile picture"
                        (click)="fileInput.click()"
                      >
                        <i class="fa fa-camera"></i>
                      </button>
                      @if (user_icon) {
                      <button
                        type="button"
                        class="avatar-action delete-action"
                        title="Remove profile picture"
                        (click)="deleteUserProfileIcon()"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                      }
                      <input
                        #fileInput
                        type="file"
                        class="hidden-file"
                        (change)="onFileChange($event)"
                        [disabled]="selectedFileList.length > 0"
                      />
                    </div>
                  </div>
                </div>
                <div class="profile-intro-content">
                  <div class="profile-title-row">
                    <div>
                      <h2>
                        {{ newUserForm.value.first_name || "Your Profile" }}
                        {{ newUserForm.value.last_name || "" }}
                      </h2>
                      <p>
                        Manage your personal information and profile details.
                      </p>
                    </div>
                    <span class="profile-status">
                      <i class="fa fa-check-circle"></i>
                      Profile
                    </span>
                  </div>
                  <div class="profile-meta">
                    <span>
                      <i class="fa fa-envelope"></i>
                      {{ newUserForm.value.email_id || "No email available" }}
                    </span>
                    @if (newUserForm.value.phone_no) {
                    <span>
                      <i class="fa fa-phone"></i>
                      {{ newUserForm.value.phone_no }}
                    </span>
                    }
                  </div>
                </div>
              </div>
              <!-- ============================================
                  IMAGE PREVIEW
                  ============================================= -->
              @if (showIconImage) {
              <div
                class="profile-image-modal"
                (click)="outsideClickIcon($event)"
              >
                <div class="profile-image-backdrop"></div>
                <div class="profile-image-container">
                  <img [src]="profileUrl + user_icon" alt="Profile preview" />
                </div>
                <button
                  type="button"
                  class="profile-image-close"
                  (click)="hideIconImage()"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              }
              <!-- ============================================
                  PERSONAL INFORMATION
                  ============================================= -->
              <section class="profile-section">
                <div class="section-heading">
                  <div class="section-heading-icon">
                    <i class="fa fa-user"></i>
                  </div>
                  <div>
                    <h3>Personal Information</h3>
                    <p>Update your basic profile information.</p>
                  </div>
                </div>
                <div class="form-grid">
                  <!-- First Name -->
                  <div class="profile-field">
                    <label for="first_name"> First Name </label>
                    <div class="input-wrapper">
                      <i class="fa fa-user input-icon"></i>
                      <input
                        id="first_name"
                        class="input"
                        type="text"
                        formControlName="first_name"
                        placeholder="Enter first name"
                      />
                    </div>
                    <form-validation
                      [control]="newUserForm.controls.first_name"
                    >
                    </form-validation>
                  </div>
                  <!-- Last Name -->
                  <div class="profile-field">
                    <label for="last_name"> Last Name </label>
                    <div class="input-wrapper">
                      <i class="fa fa-user input-icon"></i>
                      <input
                        id="last_name"
                        class="input"
                        type="text"
                        formControlName="last_name"
                        placeholder="Enter last name"
                      />
                    </div>
                    <form-validation [control]="newUserForm.controls.last_name">
                    </form-validation>
                  </div>
                  <!-- Email -->
                  <div class="profile-field">
                    <label for="email_id">
                      Email
                      <span class="required">*</span>
                    </label>
                    <div class="input-wrapper">
                      <i class="fa fa-envelope input-icon"></i>
                      <input
                        id="email_id"
                        class="input"
                        type="email"
                        formControlName="email_id"
                        readonly
                      />
                      <span class="verified-icon">
                        <i class="fa fa-check-circle"></i>
                      </span>
                    </div>
                    <form-validation [control]="newUserForm.controls.email_id">
                    </form-validation>
                  </div>
                  <!-- Phone -->
                  <div class="profile-field">
                    <label for="phone_no"> Phone </label>
                    <div class="input-wrapper">
                      <i class="fa fa-phone input-icon"></i>
                      <input
                        id="phone_no"
                        class="input"
                        type="text"
                        formControlName="phone_no"
                        placeholder="Enter phone number"
                        (keypress)="numberOnly($event)"
                      />
                    </div>
                    <form-validation [control]="newUserForm.controls.phone_no">
                    </form-validation>
                  </div>
                </div>
              </section>
              <!-- ============================================
                        LOCATION
                        ============================================= -->
              <section class="profile-section">
                <div class="section-heading">
                  <div class="section-heading-icon">
                    <i class="fa fa-map-marker"></i>
                  </div>
                  <div>
                    <h3>Location</h3>
                    <p>Add your address and location details.</p>
                  </div>
                </div>
                <div class="form-grid">
                  <!-- Address -->
                  <div class="profile-field field-full">
                    <label for="user_address"> Address </label>
                    <div class="input-wrapper">
                      <i class="fa fa-home input-icon"></i>
                      <input
                        id="user_address"
                        class="input"
                        type="text"
                        formControlName="user_address"
                        placeholder="Enter your address"
                      />
                    </div>
                  </div>
                  <!-- City -->
                  <div class="profile-field">
                    <label for="user_city"> City </label>
                    <div class="input-wrapper">
                      <i class="fa fa-building input-icon"></i>
                      <input
                        id="user_city"
                        class="input"
                        type="text"
                        formControlName="user_city"
                        placeholder="Enter city"
                      />
                    </div>
                  </div>
                  <!-- State -->
                  <div class="profile-field">
                    <label for="user_state"> State </label>
                    <div class="input-wrapper">
                      <i class="fa fa-map input-icon"></i>
                      <input
                        id="user_state"
                        class="input"
                        type="text"
                        formControlName="user_state"
                        placeholder="Enter state"
                      />
                    </div>
                  </div>
                  <!-- ZIP -->
                  <div class="profile-field">
                    <label for="user_zip"> ZIP / Postal Code </label>
                    <div class="input-wrapper">
                      <i class="fa fa-hashtag input-icon"></i>
                      <input
                        id="user_zip"
                        class="input"
                        type="text"
                        formControlName="user_zip"
                        placeholder="Enter ZIP code"
                      />
                    </div>
                  </div>
                </div>
              </section>
              <!-- ============================================
                                GENDER
                                ============================================= -->
              <section class="profile-section">
                <div class="section-heading">
                  <div class="section-heading-icon">
                    <i class="fa fa-venus-mars"></i>
                  </div>
                  <div>
                    <h3>Gender</h3>
                    <p>Select your preferred gender.</p>
                  </div>
                </div>
                <div class="gender-options">
                  <label class="gender-option">
                    <input type="radio" formControlName="gender" value="male" />
                    <span class="gender-card">
                      <span class="gender-icon">
                        <i class="fa fa-mars"></i>
                      </span>
                      <span class="gender-text"> Male </span>
                      <span class="gender-check">
                        <i class="fa fa-check"></i>
                      </span>
                    </span>
                  </label>
                  <label class="gender-option">
                    <input
                      type="radio"
                      formControlName="gender"
                      value="female"
                    />
                    <span class="gender-card">
                      <span class="gender-icon">
                        <i class="fa fa-venus"></i>
                      </span>
                      <span class="gender-text"> Female </span>
                      <span class="gender-check">
                        <i class="fa fa-check"></i>
                      </span>
                    </span>
                  </label>
                  <label class="gender-option">
                    <input
                      type="radio"
                      formControlName="gender"
                      value="others"
                    />
                    <span class="gender-card">
                      <span class="gender-icon">
                        <i class="fa fa-transgender-alt"></i>
                      </span>
                      <span class="gender-text"> Others </span>
                      <span class="gender-check">
                        <i class="fa fa-check"></i>
                      </span>
                    </span>
                  </label>
                </div>
                <form-validation [control]="newUserForm.controls.gender">
                </form-validation>
              </section>
              <!-- ============================================
                                NOTES
                                ============================================= -->
              <section class="profile-section">
                <div class="section-heading">
                  <div class="section-heading-icon">
                    <i class="fa fa-sticky-note"></i>
                  </div>
                  <div>
                    <h3>Additional Notes</h3>
                    <p>Add any additional information about your profile.</p>
                  </div>
                </div>
                <div class="profile-field">
                  <label for="user_notes"> Notes </label>
                  <textarea
                    id="user_notes"
                    class="textarea"
                    formControlName="user_notes"
                    rows="4"
                    placeholder="Write something about yourself..."
                  ></textarea>
                </div>
              </section>
              <!-- ============================================
                                ACTIONS
                                ============================================= -->
              <div class="profile-actions">
                <div class="actions-info">
                  <i class="fa fa-info-circle"></i>
                  <span>
                    Your profile information will be updated immediately.
                  </span>
                </div>
                <button
                  type="button"
                  class="save-profile-btn"
                  [disabled]="newUserForm.pristine || !newUserForm.valid"
                  (click)="updateUserDetail(newUserForm.value)" *ngIf="!showBtnSpinner"
                >
                  <i class="fa fa-save"></i>
                  <span>Save Changes</span>
                </button>
                <button
                  type="button"
                  class="save-profile-btn" *ngIf="showBtnSpinner"
                >
                  <i class="fa-solid fa-circle-notch"></i>
                  <span>Loading...</span>
                </button>
              </div>
            </form>
          </div>
          }
          <!--end-->
        </div>
        } @case ('account') {
        <div class="settings-panel">
          <!-- Change password content -->
          @if (tabName === 'account') {
          <div class="account-settings">
            <form [formGroup]="accountFrom" novalidate>
              <div class="password-page">
                <!-- Header -->
                <div class="password-header">
                  <div class="password-header-icon">
                    <i class="fa fa-shield"></i>
                  </div>
                  <div>
                    <h3>Change Password</h3>
                    <p>
                      Keep your account secure by using a strong, unique
                      password.
                    </p>
                  </div>
                </div>
                <!-- Security Notice -->
                <div class="security-notice">
                  <div class="notice-icon">
                    <i class="fa fa-info"></i>
                  </div>
                  <div>
                    <strong>Password security</strong>
                    <span>
                      Use at least 6 characters and include a number.
                    </span>
                  </div>
                </div>
                <!-- Password Form -->
                <div class="password-form">
                  <!-- Current Password -->
                  <div class="password-field">
                    <label for="old_password"> Current Password </label>
                    <div class="input-wrapper">
                      <i class="fa fa-lock field-icon"></i>
                      <input
                        id="old_password"
                        class="input"
                        type="password"
                        placeholder="Enter current password"
                        formControlName="old_password"
                      />
                    </div>
                    @if (submitted && f.old_password.errors?.required) {
                    <p class="error">
                      <i class="fa fa-exclamation-circle"></i>
                      Enter current password
                    </p>
                    }
                  </div>
                  <!-- New Password -->
                  <div class="password-field">
                    <label for="new_password"> New Password </label>
                    <div class="input-wrapper">
                      <i class="fa fa-key field-icon"></i>
                      <input
                        id="new_password"
                        class="input"
                        type="password"
                        placeholder="Enter new password"
                        formControlName="new_password"
                      />
                    </div>
                    @if (submitted && f.new_password.errors?.required) {
                    <p class="error">
                      <i class="fa fa-exclamation-circle"></i>
                      Enter new password
                    </p>
                    } @if (submitted && f.new_password.errors?.minlength) {
                    <p class="error">
                      <i class="fa fa-exclamation-circle"></i>
                      Password must be at least 6 characters long and contain a
                      number.
                    </p>
                    }
                  </div>
                  <!-- Confirm Password -->
                  <div class="password-field">
                    <label for="confirm_password"> Confirm Password </label>
                    <div class="input-wrapper">
                      <i class="fa fa-check-circle field-icon"></i>
                      <input
                        id="confirm_password"
                        class="input"
                        type="password"
                        placeholder="Confirm new password"
                        formControlName="confirm_password"
                      />
                    </div>
                    @if (submitted && f.confirm_password.errors?.required) {
                    <p class="error">
                      <i class="fa fa-exclamation-circle"></i>
                      Confirm new password
                    </p>
                    } @if (submitted && f.confirm_password.errors?.mustMatch) {
                    <p class="error">
                      <i class="fa fa-exclamation-circle"></i>
                      Password doesn't match. Please re-enter.
                    </p>
                    }
                  </div>
                  <!-- Password Tips -->
                  <div class="password-tips">
                    <span class="tips-title">
                      <i class="fa fa-lightbulb-o"></i>
                      Password tips
                    </span>
                    <div class="tips-list">
                      <span>
                        <i class="fa fa-check"></i>
                        At least 6 characters
                      </span>
                      <span>
                        <i class="fa fa-check"></i>
                        Include a number
                      </span>
                      <span>
                        <i class="fa fa-check"></i>
                        Avoid common passwords
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Footer -->
                <div class="account-actions">
                  <button
                    type="button"
                    class="button cancel-btn"
                    (click)="accountFrom.reset()"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="button update-btn"
                    [disabled]="!accountFrom.valid"
                    (click)="updateAccountPassword(accountFrom.value)"
                  >
                    <i class="fa fa-lock"></i>
                    Update Password
                  </button>
                </div>
              </div>
            </form>
          </div>
          }
          <!--end-->
        </div>
        } @case ('layout') {
        <div class="settings-panel">
          <!-- Layout content -->
          @if (tabName === 'layout') {
          <div class="layout-settings">
            <!-- HEADER -->
            <div class="layout-header">
              <div class="layout-header-icon">
                <i class="fa fa-desktop"></i>
              </div>
              <div>
                <h4 class="layout-title">Bot Layout</h4>
                <p class="layout-subtitle">
                  Choose how your bot interface should appear.
                </p>
              </div>
            </div>
            <!-- LAYOUT OPTIONS -->
            <div class="layout-grid">
              <!-- DEFAULT LAYOUT -->
              <label
                class="layout-card"
                [class.active]="chat_layout.default_layout === true"
              >
                <input
                  type="radio"
                  name="chatLayout"
                  [(ngModel)]="chat_layout.default_layout"
                  [value]="true"
                  (ngModelChange)="
                    updateUserSettings(chat_layout, 'chat_layout')
                  "
                />
                <div class="layout-card-header">
                  <div class="layout-option-icon">
                    <i class="fa fa-th-large"></i>
                  </div>
                  <div class="layout-radio">
                    <span></span>
                  </div>
                </div>
                <div class="layout-preview">
                  <img
                    src="../../../assets/images/F_layout_on.png"
                    alt="Default Layout Preview"
                  />
                </div>
                <div class="layout-info">
                  <h5>Default Layout</h5>
                  <p>
                    A traditional interface with a simple and familiar
                    structure.
                  </p>
                </div>
                @if (chat_layout.default_layout === true) {
                <div class="selected-label">
                  <i class="fa fa-check"></i>
                  Selected
                </div>
                }
              </label>
              <!-- COMPACT GRID LAYOUT -->
              <label
                class="layout-card"
                [class.active]="chat_layout.default_layout === false"
              >
                <input
                  type="radio"
                  name="chatLayout"
                  [(ngModel)]="chat_layout.default_layout"
                  [value]="false"
                  (ngModelChange)="
                    updateUserSettings(chat_layout, 'chat_layout')
                  "
                />
                <div class="layout-card-header">
                  <div class="layout-option-icon">
                    <i class="fa fa-th"></i>
                  </div>
                  <div class="layout-radio">
                    <span></span>
                  </div>
                </div>
                <div class="layout-preview">
                  <img
                    src="../../../assets/images/Z_layout_on.png"
                    alt="Compact Grid Layout Preview"
                  />
                </div>
                <div class="layout-info">
                  <h5>Compact Grid Layout</h5>
                  <p>
                    A compact arrangement designed to display more content
                    efficiently.
                  </p>
                </div>
                @if (chat_layout.default_layout === false) {
                <div class="selected-label">
                  <i class="fa fa-check"></i>
                  Selected
                </div>
                }
              </label>
            </div>
          </div>
          }
          <!--end-->
        </div>
        } @case ('notification') {
        <div class="settings-panel">
          <!-- Notification content -->
          @if (tabName === 'notification') {
          <div
            class="notification-settings userProfile-scroll scroll-bar pos-relative"
            infinite-scroll
          >
            <form #settingsForm="ngForm" novalidate>
              <!-- PAGE HEADER -->
              <div class="notification-header">
                <div class="notification-header-icon">
                  <i class="fa fa-bell"></i>
                </div>
                <div>
                  <h4>Notifications</h4>
                  <p>Manage how and when you receive notifications.</p>
                </div>
              </div>
              <!-- GENERAL NOTIFICATIONS -->
              <section class="notification-card">
                <div class="card-heading">
                  <div class="heading-icon">
                    <i class="fa fa-bell-o"></i>
                  </div>
                  <div>
                    <h5>General Notifications</h5>
                    <p>
                      Choose which activities you want to be notified about.
                    </p>
                  </div>
                </div>
                <div class="notification-list">
                  @for (setting of settingsList; track trackByFn($index,
                  setting)) {
                  <div class="notification-item">
                    <div class="notification-item-content">
                      <div class="notification-item-icon">
                        <i class="fa fa-bell"></i>
                      </div>
                      <div class="notification-text">
                        <span class="notification-name">
                          {{ setting.display_name }}
                        </span>
                        <span class="notification-description">
                          Receive alerts related to this activity.
                        </span>
                      </div>
                    </div>
                    <label class="toggle-switch">
                      <input
                        type="checkbox"
                        id="{{ setting.field_name }}"
                        name="{{ setting.field_name }}"
                        [(ngModel)]="settingsDetail[setting.field_name]"
                        (ngModelChange)="
                          settingChange(
                            setting.field_name,
                            settingsDetail[setting.field_name]
                          )
                        "
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                  }
                </div>
              </section>
              <!-- DESKTOP NOTIFICATIONS -->
              <section class="notification-card">
                <div class="card-heading">
                  <div class="heading-icon desktop-icon">
                    <i class="fa fa-desktop"></i>
                  </div>
                  <div>
                    <h5>Desktop Notifications</h5>
                    <p>Control notifications that appear on your desktop.</p>
                  </div>
                </div>
                <div class="notification-item">
                  <div class="notification-item-content">
                    <div class="notification-item-icon desktop">
                      <i class="fa fa-desktop"></i>
                    </div>
                    <div class="notification-text">
                      <span class="notification-name"> Desktop Alerts </span>
                      <span class="notification-description">
                        Show notifications when you're using the application.
                      </span>
                    </div>
                  </div>
                  <label class="toggle-switch">
                    <input
                      type="checkbox"
                      id="enable_desktop_alert"
                      name="enable_desktop_alert"
                      [(ngModel)]="settingsDetail.enable_desktop_alert"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </section>
              <!-- SAVE FOOTER -->
              <div class="notification-actions">
                @if (settingsForm.dirty) {
                <div class="save-status">
                  <i class="fa fa-circle"></i>
                  Unsaved changes
                </div>
                }
                <button
                  class="button save-btn"
                  type="button"
                  [disabled]="!settingsForm.dirty"
                  (click)="
                    updateUserSettings(settingsDetail, null, settingsForm)
                  "
                >
                  <i class="fa fa-save"></i>
                  Save Changes
                </button>
              </div>
            </form>
          </div>
          }
          <!--end-->
        </div>
        } @case ('logo') {
        <div class="settings-panel">
          <!-- Company logo content -->
          @if (tabName === 'logo') {
          <div class="logo-settings">
            <form [formGroup]="instituteForm" novalidate>
              <div class="logo-card">
                <!-- HEADER -->
                <div class="logo-card-header">
                  <div class="logo-header-icon">
                    <i class="fas fa-building"></i>
                  </div>
                  <div>
                    <h4 class="logo-title">Company Branding</h4>
                    <p class="logo-subtitle">
                      Manage your company logo and branding information.
                    </p>
                  </div>
                </div>
                <!-- LOGO UPLOAD -->
                <div class="branding-section">
                  <div class="section-heading">
                    <div>
                      <h5>Company Logo</h5>
                      <p>Upload a PNG or JPG image for your company profile.</p>
                    </div>
                    <span class="file-format"> PNG / JPG </span>
                  </div>
                  <div
                    class="logo-upload-box"
                    [class.has-logo]="preUploadedFile?.company_logo"
                    (click)="logoFileInput.click()"
                  >
                    <!-- EMPTY STATE -->
                    @if (!preUploadedFile?.company_logo) {
                    <div class="upload-icon">
                      <i class="fas fa-cloud-upload-alt"></i>
                    </div>
                    <h6>Upload company logo</h6>
                    <p>Click here to browse your files</p>
                    <span class="upload-hint">
                      Recommended size: 200 × 200 px
                    </span>
                    }
                    <!-- PREVIEW -->
                    @if (preUploadedFile?.company_logo) {
                    <div class="logo-preview">
                      <img
                        [src]="companyUrl + preUploadedFile.company_logo"
                        alt="Company logo"
                      />
                    </div>
                    <div class="logo-preview-info">
                      <strong>Company Logo</strong>
                      <span>Click to replace</span>
                    </div>
                    }
                    <!-- REMOVE -->
                    @if (preUploadedFile?.company_logo) {
                    <button
                      type="button"
                      class="remove-logo-btn"
                      (click)="
                        deleteInstituteLogoIcon(); $event.stopPropagation()
                      "
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                    }
                  </div>
                  <input
                    #logoFileInput
                    type="file"
                    class="hidden-file"
                    accept=".png,.jpg,.jpeg"
                    (change)="onLogoImgChange($event)"
                    [disabled]="selectedLogoFileList.length > 0"
                  />
                </div>
                <!-- BRANDING INFORMATION -->
                <div class="branding-section">
                  <div class="section-heading">
                    <div>
                      <h5>Brand Information</h5>
                      <p>
                        Configure the title and caption displayed with your
                        company branding.
                      </p>
                    </div>
                  </div>
                  <div class="logo-form-grid">
                    <!-- TITLE -->
                    <div class="form-field">
                      <label class="field-label">
                        Title
                        <span class="required">*</span>
                      </label>
                      <div class="input-wrapper">
                        <i class="fas fa-heading"></i>
                        <input
                          class="input"
                          type="text"
                          placeholder="Enter company title"
                          formControlName="title"
                        />
                      </div>
                      <form-validation [control]="instituteForm.controls.title">
                      </form-validation>
                    </div>
                    <!-- CAPTION -->
                    <div class="form-field">
                      <label class="field-label">
                        Caption
                        <span class="required">*</span>
                      </label>
                      <div class="input-wrapper">
                        <i class="fas fa-align-left"></i>
                        <input
                          class="input"
                          type="text"
                          placeholder="Enter company caption"
                          formControlName="caption"
                        />
                      </div>
                      <form-validation
                        [control]="instituteForm.controls.caption"
                      >
                      </form-validation>
                    </div>
                  </div>
                </div>
                <!-- FOOTER -->
                <div class="logo-actions">
                  <div class="action-info">
                    <i class="fas fa-shield-alt"></i>
                    <span
                      >Your branding changes will be visible across the
                      platform.</span
                    >
                  </div>
                  @if (!showBtnSpinner) {
                  <button
                    type="button"
                    class="save-btn"
                    [disabled]="
                      (instituteForm.valid && !instituteForm.dirty) ||
                      instituteForm.invalid
                    "
                    (click)="updateInstituteData(instituteForm.value)"
                  >
                    <i class="fas fa-check"></i>
                    Update Branding
                  </button>
                  } @if (showBtnSpinner) {
                  <button type="button" class="save-btn loading">
                    <i class="fas fa-spinner fa-spin"></i>
                    Updating...
                  </button>
                  }
                </div>
              </div>
            </form>
          </div>
          }
          <!--end-->
        </div>
        } }
      </div>
    </main>
  </div>
</div>
